import React from "react";
import { Link } from "react-router-dom";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import FooterTwo from "../common/footer/FooterTwo";
import "../common/styles/panel.css";
import { useTranslation } from "react-i18next";

const CaseStudy = () => {
  const { t } = useTranslation();
  
  // 数据源：案例卡片
  const caseStudies = [
    {
      to: "/CaseStudy/adelaide-tech",
      icon: t("case_study.adelaide_tech.icon"),
      title: t("case_study.adelaide_tech.title"),
      image: "/images/about/ashely.png",
    },
    {
      to: "/CaseStudy/lorenzo-journey",
      icon: t("case_study.lorenzo.icon"),
      title: t("case_study.lorenzo.title"),
      image: "/images/about/lorenzo1.png",
    },
    {
      to: "/CaseStudy/ashley-dream",
      icon: t("case_study.ashley.icon"),
      title: t("case_study.ashley.title"),
      image: "/images/about/Ashley.png",
    },
  ];
  
  return (
    <>
      <SEO title="Case Study - Cyberate Investments" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

        <div className="container page-content-text" style={{ paddingTop: 160, paddingBottom: 100 }}>
          <h1 className="cy-section-title text-center" style={{ color: '#fff', marginBottom: 20 }}>{t("case_study.title")}</h1>
          <p className="text-center" style={{ color: '#fff', fontSize: '18px', marginBottom: 40 }}>
            {t("case_study.subtitle")}
          </p>

          {/* Case Study Cards Container */}
          <div className="cy-panel cy-panel--p40" style={{ marginBottom: 28, background: '#000' }}>
            <div className="row">
              {caseStudies.map((item, idx) => (
                <div className="col-lg-4 col-md-6 col-sm-12" style={{ marginBottom: 30 }} key={idx}>
                  <Link to={item.to} style={{ textDecoration: 'none' }}>
                    <div
                      className="case-study-card"
                      style={{
                        background: 'rgba(255, 255, 255, 0.1)',
                        borderRadius: '12px',
                        padding: '20px',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        border: '1px solid rgba(255, 200, 47, 0.3)'
                      }}
                      onMouseEnter={(e) => {
                        const el = e.currentTarget;
                        el.style.transform = 'translateY(-5px)';
                        el.style.boxShadow = '0 10px 25px rgba(255, 200, 47, 0.2)';
                      }}
                      onMouseLeave={(e) => {
                        const el = e.currentTarget;
                        el.style.transform = 'translateY(0)';
                        el.style.boxShadow = 'none';
                      }}
                    >
                      <div
                        className="case-study-image"
                        style={{
                          height: '200px',
                          borderRadius: '8px',
                          marginBottom: '20px',
                          overflow: 'hidden'
                        }}
                      >
                        <img 
                          src={item.image} 
                          alt={item.title}
                          className="img-fluid"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                      </div>
                      <div className="case-study-content" style={{ flex: 1 }}>
                        <div
                          className="case-study-icon"
                          style={{
                            width: '40px',
                            height: '40px',
                            background: '#007bff',
                            borderRadius: '8px',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <span style={{ color: '#fff', fontSize: '20px' }}>{item.icon}</span>
                        </div>
                        <h4 style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '10px' }}>
                          {item.title}
                        </h4>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>

        <FooterTwo />
      </main>
    </>
  );
};

export default CaseStudy;
